import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-circle-question",
  "use": "icon-circle-question-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol viewBox=\"0 0 24 24\" id=\"icon-circle-question\"><path d=\"M12 24C5.373 24 0 18.627 0 12S5.373 0 12 0s12 5.373 12 12-5.373 12-12 12zm0-2c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10zm-1-5a1 1 0 1 1 2 0 1 1 0 0 1-2 0zm2-3a1 1 0 0 1-2 0v-1.004a1 1 0 0 1 .767-.973c1.6-.383 2.233-1.196 2.233-1.96C14 8.81 13.123 8 12 8s-2 .81-2 2.063a1 1 0 0 1-2 0C8 7.668 9.807 6 12 6s4 1.669 4 4.063c0 1.652-1.078 2.802-3 3.442V14z\" fill=\"currentColor\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./app/icons/icon-circle-question.svg
// module id = 866
// module chunks = 74